<template>
    <img
        v-if="result"
        :src="loadImage ? result.src : getBasePreview"
        :alt="result.alt"
        :title="result.alt"
        :style="imageStyle"
        :width="result.width"
        :height="result.height"
        class="def-img"
    >
</template>

<script>
export default {
    name: 'DefImg',
    props: {
        result: Object,
        maxWidth: String,
        maxHeight: String,
        maxSizeOff: {
            type: Boolean,
            default: false,
        },
        loadImageNow: {
          type: Boolean,
          default: false,
        }
    },
    data() {
        return {
            intersectionObserver: null,
            options: {
                rootMargin: '100px',
                threshold: .01,
            },
            loadImage: this.loadImageNow,
        }
    },
    computed: {
        getBasePreview() {
            try {
                let canvas = document.createElement('canvas');
                canvas.width = this.result.width;
                canvas.height = this.result.height;
                return canvas.toDataURL();
            } catch (err) {
                console.error(err);
            }
        },
        imageStyle() {
            try {
                if (!this.maxSizeOff) {
                    if (this.result?.height > this.result?.width) {
                        return `max-height: ${ this.maxHeight ?? '100%' };`;
                    } else {
                        return `max-width: ${ this.maxWidth ?? '100%' };`;
                    }
                }
                return '';
            } catch (err) {
                console.error(err);
            }
        },
    },
    methods: {
        observerCallBack (entries) {
            try {
                // If intersectionRatio is 0, the target is out of view
                // and we do not need to do anything.
                // console.log(entries[0].intersectionRatio);
                if (entries[0].intersectionRatio <= 0) return;

                this.loadImage = true;
                this.intersectionObserver.unobserve(this.$el);
            } catch (err) {
                console.error(err);
            }
        }
    },
    mounted() {
        try {
            if (this.result && !this.intersectionObserver) {
                if ('IntersectionObserver' in window) {
                    // LazyLoad images using IntersectionObserver
                    this.intersectionObserver = new IntersectionObserver(this.observerCallBack, this.options);
                    this.intersectionObserver.observe(this.$el);
                }  else {
                    // Load all images at once
                    this.loadImage = true;
                }
            }
        } catch (err) {
            console.error(err);
        }
    },
    beforeUnmount() {
        try {
            if (
                'IntersectionObserver' in window &&
                this.result &&
                this.intersectionObserver
            ) {
                this.intersectionObserver.unobserve(this.$el);
            }
        } catch (err) {
            console.error(err);
        }
    }
}
</script>

<style lang="scss" scoped>
.def-img{
    display: block;
    height: auto;
    width: 100%;
}
</style>